import { Box, Paragraph, Heading } from 'grommet'
import Image from 'next/image'
import styled, { css } from 'styled-components'

import { ImageWithPlaceholder } from '@components/ImageWithPlaceholder'

export const Wrapper = styled(Box)`
  overflow: hidden;
`

export const GeneralImage = styled(Image)`
  position: absolute;
`

export const Hexagon = styled(Image)`
  position: absolute;

  ${({ theme }) => css`
    ${theme.below.laptopM`
      display: none;
    `}
  `}
`

export const SubTitle = styled(Paragraph)`
  max-width: 100%;
  white-space: pre-wrap;

  ${({ theme }) => css`
    ${theme.getTypography('desktop', 'body', 'body2')}

    color: ${theme.newColors.darkGray};

    ${theme.below.mobileXL`
      ${theme.getTypography('mobile', 'body', 'body4')}

      text-align: start;
    `};
  `}
`

export const Title = styled(Heading)`
  width: 100%;

  ${({ theme }) => css`
    ${theme.getTypography('desktop', 'title', 'title1')}

    color: ${theme.newColors.primary};
    margin-bottom: ${theme.newSpaces.xs}px;

    ${theme.below.mobileXL`
      ${theme.getTypography('mobile', 'title', 'title1')}
    `}
  `}
`

export const MainImage = styled(ImageWithPlaceholder)`
  height: 100%;
  margin: 0 auto;
  object-fit: cover;
  width: 100%;

  ${({ theme }) => css`
    ${theme.below.laptop`
      max-width: 100%;
    `}
  `}
`

export const WrapperImage = styled(Box)`
  margin-top: 40px;
  position: relative;
`

export const List = styled.ul`
  ${({ theme }) => css`
    list-style-image: url('/images/cases/telehealth-software/svg/list-hexagon.svg');
    margin-bottom: ${theme.newSpaces.xs}px;
    margin-top: ${theme.newSpaces.xs}px;
    padding-left: ${theme.newSpaces.sm}px;

    ${theme.below.tabletS`
      list-style-image: none;
    `}
  `}
`

export const ListItem = styled.li`
  ${({ theme }) => css`
    ${theme.getTypography('desktop', 'body', 'body2')}

    color: ${theme.newColors.darkGray};

    margin: ${theme.newSpaces.sm}px 0;
    padding-left: ${theme.newSpaces.xs2}px;

    ${theme.below.mobileXL`
      ${theme.getTypography('mobile', 'body', 'body4')};

      margin: 0;
    `}
  `}
`

export const DefaultListItem = styled(ListItem)`
  margin: 0;
`

export const DefaultList = styled(List)`
  list-style-image: none;
`
export const Text = styled(Paragraph)`
  max-width: 100%;
  white-space: pre-wrap;
  z-index: 5;

  ${({ theme }) => css`
    ${theme.getTypography('desktop', 'body', 'body2')}

    color: ${theme.newColors.darkGray};

    ${theme.below.mobileXL`
      ${theme.getTypography('mobile', 'body', 'body4')}
    `}
  `}
`

export const CustomResult = styled.p`
  font-size: 30px;
  height: 40px;
  line-height: 37px;
  width: 294px;
`
